import { HttpRequestException } from '../api/client';

export type SeastarReason = 'SessionEnd' | 'SessionExpire' | 'SessionError';

export const isSessionAccessDenied = (err: unknown): boolean =>
  err instanceof HttpRequestException &&
  (err.status === 403 || err.status === 404);

export const redirectSessionTerminal = (
  seastarLocation: string | undefined,
  reason: SeastarReason,
): void => {
  if (seastarLocation) {
    window.location.href = `${seastarLocation}&reason=${reason}`;
  } else {
    window.location.search = '?finished=true';
  }
};
